import { Box } from "@mui/material";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";

import { ContactPersonStatus } from "../_types/workforcePresence.types";
import {
  getPresenceDotColor,
  isMobileOnlyPresence,
  shouldShowContactPresence,
} from "../_utils/workforcePresence.utils";

interface ContactPresenceDotProps {
  contactType: string;
  personStatus?: ContactPersonStatus | null;
}

export const ContactPresenceDot = ({
  contactType,
  personStatus,
}: ContactPresenceDotProps) => {
  if (!shouldShowContactPresence(contactType, personStatus)) {
    return null;
  }

  if (isMobileOnlyPresence(personStatus)) {
    return (
      <Box
        sx={{
          position: "absolute",
          right: 0,
          bottom: -2,
          width: 16,
          height: 16,
          borderRadius: "50%",
          bgcolor: getPresenceDotColor(personStatus),
          border: "2px solid var(--fx-surface-base, #FFFFFF)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
        }}
      >
        <PhoneAndroidIcon sx={{ fontSize: 9, color: "#ffffff" }} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "absolute",
        right: 2,
        bottom: 0,
        width: 10,
        height: 10,
        borderRadius: "50%",
        bgcolor: getPresenceDotColor(personStatus),
        border: "2px solid var(--fx-surface-base, #FFFFFF)",
        zIndex: 1,
      }}
    />
  );
};
